module.exports = __webpack_public_path__ + "img/icon-2.b1555987.png";